/** Position badge with podium styling — P1 gold, P2 silver, P3 bronze */

interface PositionBadgeProps {
  position: number;
  size?: 'sm' | 'md';
}

const PODIUM: Record<number, { bg: string; text: string; border: string }> = {
  1: { bg: 'rgba(255, 215, 0, 0.12)', text: '#FFD700', border: 'rgba(255, 215, 0, 0.3)' },
  2: { bg: 'rgba(192, 192, 192, 0.10)', text: '#C0C0C0', border: 'rgba(192, 192, 192, 0.25)' },
  3: { bg: 'rgba(205, 127, 50, 0.12)', text: '#CD7F32', border: 'rgba(205, 127, 50, 0.3)' },
};

export function PositionBadge({ position, size = 'md' }: PositionBadgeProps) {
  const podium = PODIUM[position];
  const sizeClass = size === 'sm' ? 'w-6 h-6 text-[10px]' : 'w-8 h-8 text-xs';

  if (podium) {
    return (
      <span
        className={`inline-flex items-center justify-center rounded-full font-bold mono ${sizeClass}`}
        style={{
          background: podium.bg,
          color: podium.text,
          border: `1px solid ${podium.border}`,
          boxShadow: `0 0 8px ${podium.bg}`,
        }}
      >
        {position}
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center justify-center rounded-full font-medium mono text-text-secondary bg-bg-surface border border-border-subtle ${sizeClass}`}>
      {position}
    </span>
  );
}
